import type { ThemeConfig } from 'antd';
import { theme as antdTheme } from 'antd';
import Theme from './theme';

export const CSS_VAR_KEY_LIGHT = 'buddy-theme-light';
export const CSS_VAR_KEY_DARK = 'buddy-theme-dark';

/**
 * Builds the antd `ConfigProvider` theme for a colour mode.
 *
 * The `cssVar.key` is deliberately different per mode. antd v6 runs in
 * CSS-variable mode unconditionally and, unlike v5, hands every algorithm the
 * same default key ('css-var-root'). Light and dark then share a single
 * `<style data-token-hash>` element *and* a single refcount bucket inside
 * cssinjs' `cleanTokenStyle`, so tearing down one mode's cache entry can remove
 * the variables the other mode just wrote — intermittently leaving components
 * with no `--ant-*` values after a mode switch. One key per mode keeps the two
 * in separate style elements, which is what `antd-theme.test.tsx` pins down.
 */
export const buildAntdTheme = (isDark: boolean): ThemeConfig => ({
  token: {
    fontFamily: 'Inter',
    colorPrimary: Theme.colors.primary,
  },
  cssVar: { key: isDark ? CSS_VAR_KEY_DARK : CSS_VAR_KEY_LIGHT },
  algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
});
